import WhyUs from './WhyUs.component';
export default WhyUs;